import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './reassign-banner.module.css';
import { Box, Cluster } from '@dropbox/dig-foundations';
import { Link, Text } from '@dropbox/dig-components/typography';

type Props = {
  setModals: (modals: {
    reassign: boolean;
    decline: boolean;
    eid: boolean;
  }) => void;
};

const ReassignBanner: React.FC<Props> = ({ setModals }) => {
  const handleCTAClick = () => {
    setModals({ reassign: true, decline: false, eid: false });
  };

  return (
    <Box backgroundColor="Secondary Surface - State 1">
      <Cluster
        alignX="center"
        alignY="center"
        gap="Micro XSmall"
        padding="Micro XSmall"
      >
        <Cluster.Item>
          <Text color="subtle">
            <FormattedMessage
              id="signer.subheader.delegate.message"
              description="text in signer flow while reassigning, informing that the new signer is not authorize to access the document"
              defaultMessage="Not the authorized signer?"
            />
          </Text>
        </Cluster.Item>

        <Cluster.Item>
          <Text className={styles.linkText}>
            <Link href={'#'} onClick={handleCTAClick} hasNoUnderline>
              <FormattedMessage
                id="signer.subheader.delegate.ctaMessage"
                description="text in signer flow while reassigning, asking signer to pick new signer to reassign"
                defaultMessage="Assign to someone else"
              />
            </Link>
          </Text>
        </Cluster.Item>
      </Cluster>
    </Box>
  );
};

export default ReassignBanner;
